export default __webpack_public_path__ + "static/media/faq.153aa36e.svg";